"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgVolume2 = function SvgVolume2(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M31.777 16.223c4.294 4.295 4.294 11.259 0 15.554a1 1 0 11-1.414-1.414 9 9 0 000-12.726 1 1 0 111.414-1.414zM24 17v14a1 1 0 01-1.625.78L17.65 28H14a1 1 0 01-1-1v-6a1 1 0 011-1h3.65l4.725-3.78A1 1 0 0124 17zm-2 2.08l-3.375 2.7A1 1 0 0118 22h-3v4h3a1 1 0 01.625.22L22 28.92v-9.84zm6.247.673a6 6 0 010 8.484 1 1 0 11-1.414-1.414 4 4 0 000-5.656 1 1 0 111.414-1.414z",
    id: "volume-2_svg__a"
  }));
};

var _default = SvgVolume2;
exports["default"] = _default;